import type {
  AlertChartOption,
  AlertScoreboardItem,
} from '@/dashboard/features/widgets/alert/settings/domain/alertChartOption';

export const DEFAULT_SCOREBOARD_ITEMS: AlertScoreboardItem[] = [
  { level: 'Critical', alias: 'Critical' },
  { level: 'Warning', alias: 'Warning' },
  { level: 'Normal', alias: 'Normal' },
];

export const EXCLUDED_TABLE_COLUMN_FIELDS = ['alertRuleId', 'targetId'];

export const DEFAULT_ALERT_CHART_OPTION: AlertChartOption = {
  sortBy: null,
  orderBy: 'ASC',
  chartDataSortByStat: null,
  sortByStatOptions: [],
  scoreboardStatusColorType: 'text',
  scoreboardItems: DEFAULT_SCOREBOARD_ITEMS,
  tableColumns: [],
  hideColumnHeader: false,
  hideFilterSearch: false,
};
